export default __webpack_public_path__ + "static/large-headings-do-460f3b7be8209369c4d5ed528c52195b.png";